<template>
<input ref="input"
	v-model="value"
	type="number"
	class="number-ticker"
	:min="min" :max="max"
>
<div class="quantity-nav">
	<div class="quantity-button quantity-up"
		@click.prevent="increment"
	>
		+
	</div>
	<div class="quantity-button quantity-down"
		@click.prevent="decrement"
	>
		-
	</div>
</div>
</template>

<script>
export default {
	props: {
		min: {
			type: Number,
			default: 0
		},
		max: {
			type: Number,
			default: 100
		}
	},
	data: () => ({
		value: 0
	}),
	methods: {
		increment(){
			this.value = this.value < this.max
				? this.value + 1
				: this.value
		},
		decrement(){
			this.value = this.value > this.min
				? this.value - 1
				: this.value
		}
	}
}
</script>